import React from "react";
import CareerHeaderImage from "../../assets/images/career/part-of-team.png";

const AboutSection = () => {
  return (
    <section className="tw-py-20 lg:tw-py-24 tw-bg-[#F5F4FF]/50 tw-border-b tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Layout Grid */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          
          {/* Left Column: Image */}
          <div className="lg:tw-col-span-5 tw-flex tw-justify-center">
            <div className="tw-relative">
              <img
                src={CareerHeaderImage}
                alt="Come be a part of the team that's making it happen"
                className="tw-max-w-full tw-h-auto tw-rounded-3xl img-shadow-purple"
              />
            </div>
          </div>

          {/* Right Column: Text Content */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-4">
              Come be a part of the team that's making it happen
            </h2>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-m-0">
              Together, we can turn our vision into reality and make a positive impact in the world.
            </p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default AboutSection;
